import React from 'react';

import { AgentContextPageLoader } from '@confluence/space-settings/entry-points/AgentContextPageLoader.ts';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { SPACE_SETTINGS_DETAILS } from '@confluence/named-routes/entry-points/routes.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';

import SpaceBase from '../../SpaceBase/index.js';

export const SpaceSettingsAgentContextRoute = ({ params: { spaceKey } }) => {
	if (!expValEquals('cc_space_agents_md_context', 'isEnabled', true)) {
		return <Redirection name={SPACE_SETTINGS_DETAILS.name} params={{ spaceKey }} />;
	}

	return (
		<SpaceBase>
			<AgentContextPageLoader spaceKey={spaceKey} />
		</SpaceBase>
	);
};

SpaceSettingsAgentContextRoute.NAVIGATION_PARAMS = ({ params: { spaceKey } }) => ({
	Screen: {
		screenEvent: { name: 'agenticSpaceInstructions' },
		pageState: { spaceKey },
	},
	MainLayout: {
		navView: CONTAINER_HOME_ID,
	},
});
